import styled, { css } from 'styled-components';
import { tokens } from '../../../design/tokens';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;

  > label {
    color: ${tokens.color.textAsh};
    font-size: ${tokens.font.label.size};
    font-weight: ${tokens.font.label.weight};
  }
`;

export const Trigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  min-height: 44px;
  padding: 0 14px;
  text-align: left;
  background: ${tokens.color.fieldSlate};
  border: 1px solid transparent;
  border-radius: ${tokens.radius.sm};
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};
  cursor: pointer;
  transition: border-color 0.2s, background-color 0.2s;

  &:hover:not(:disabled) {
    border-color: ${tokens.color.railGraphite};
  }

  &:focus-visible {
    outline: 2px solid ${tokens.color.focusAmber};
    outline-offset: 2px;
  }

  &:disabled {
    opacity: 0.55;
    cursor: not-allowed;
  }

  svg {
    flex-shrink: 0;
    transition: transform 0.2s;
  }

  svg.open {
    transform: rotate(180deg);
  }
`;

export const TriggerLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Placeholder = styled.span`
  color: ${tokens.color.textAsh};
`;

export const Panel = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: ${tokens.zIndex.modal};
  max-height: 260px;
  overflow-y: auto;
  padding: 4px;
  background: ${tokens.color.cardCharcoal};
  border: 1px solid ${tokens.color.railGraphite};
  border-radius: ${tokens.radius.sm};
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);

  &:focus {
    outline: none;
  }
`;

interface IOption {
  active: boolean;
  selected: boolean;
}

export const Option = styled.button<IOption>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  text-align: left;
  background: transparent;
  border: 0;
  border-radius: ${tokens.radius.xs};
  color: ${tokens.color.textWhite};
  font-size: ${tokens.font.body.size};
  cursor: pointer;

  ${({ active }) =>
    active &&
    css`
      background: ${tokens.color.railGraphite};
    `}

  ${({ selected }) =>
    selected &&
    css`
      color: ${tokens.color.marqueeGold};
    `}

  svg {
    flex-shrink: 0;
  }
`;

export const OptionLabel = styled.span`
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;

  small {
    color: ${tokens.color.textAsh};
    font-size: ${tokens.font.caption.size};
  }
`;

export const EmptyOption = styled.div`
  padding: 12px;
  color: ${tokens.color.textAsh};
  font-size: ${tokens.font.body.size};
  text-align: center;
`;
